//
// SASDriveFileManager.js
// transport
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../lib";
import "./SubserviceManager";
import "../util/reportcentral/operations/AbstractOperation";
import "./warnings/TransportWarning";
import "../models/local/SASDriveFile";

var SASDriveFileManager = createModule("transport::SASDriveFileManager", ["transport::SubserviceManager"], EventDispatcher, [
    ,
    ,
    ,
    ,
    {
        sasDriveFileFrom: [1,7],
        removeAllSASDriveFilesDeviceOnly: [1],
        createReportPackageFromReport: [1,1],
        createDownloadOperation: [1,7,1],
        importFile: [7,7,9],
        removeSASDriveFileDeviceOnly: [1,7],
    },
    ,
    ,
]);
export default SASDriveFileManager;
